<template>
	<!-- MAIN CONTENT -->
	<div class="w-full md:w-3/4 lg:w-4/5 h-full flex flex-col items-start pair-bg md:rounded-tr-2xl md:rounded-bl-none rounded-br-2xl rounded-bl-2xl z-10 overflow-y-auto custom-scrollbar">
		<div class="md:hidden flex flex-col bg-[var(--mobile-header-bg-color)] rounded-t-2xl w-full">
			<!-- <div class="flex justify-end w-full px-4">
			<button @click="startSync" class="p-2 mr-4">
			<img src="./assets/Refresh.png" alt="Refresh" class="w-6 h-6"/>
			</button>
			</div>-->
			<div class="flex justify-between items-center w-full px-4 py-2 mt-2 mb-4">
				<div class="flex items-center space-x-2 px-4">
					<img :src="(currentTheme==='dark'||currentTheme==='navy') ? darkWallet : lightWallet" alt="Wallet" class="w-7 h-7"/>
					<span class="text-3xl font-archivomedium text-[var(--text-color)]">
						Wallet
					</span>
				</div>

				<!-- MOBILE DROPDOWN -->
				<div v-if="!btcOnly" class="relative mr-4">
					<button @click.stop="$emit('toggleChainDropdown')" class="flex items-center space-x-1 px-3 py-2 rounded-full bg-[var(--dropdown-bg-color)] shadow font-archivolight text-[var(--secondary-text-color)] hover:bg-[var(--accent-color)] hover:text-[var(--hover-text-color)] transition">
						<span class="text-xs px-1">
							{{ selectedChain.name }}
						</span>
						<img :src="selectedChain.icon" alt="Chain Icon" class="w-5 h-5"/>
						<svg :class="{ 'rotate-180': chainDropdownOpen }" class="w-4 h-4 transition-transform" fill="currentColor" viewBox="0 0 20 20">
							<path fill-rule="evenodd" d="M5.293 7.293 10 11.586l4.707-4.707" clip-rule="evenodd"/>
						</svg>
					</button>

					<transition name="dropdown-transition">
						<div v-if="chainDropdownOpen" class="relative">
							<!-- backdrop -->
							<div class="fixed inset-0 z-10" @click="$emit('toggleChainDropdown')"/>
							<!-- menu -->
							<div class="absolute right-0 mt-2 w-48 bg-[var(--dropdown-bg-color)] rounded-lg shadow-lg z-50">
								<button v-for="chain in displayedChains" :key="chain.name" @click="$emit('selectChain', chain)" class="flex items-center px-4 py-2 hover:bg-[var(--accent-color)] rounded-lg w-full text-left text-[var(--secondary-text-color)] hover:text-[var(--hover-text-color)] font-archivolight">
									<img :src="chain.icon" class="w-5 h-5 mr-2"/>
									<span>
										{{ chain.name }}
									</span>
								</button>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>

		<!-- DESKTOP HEADER -->
		<div class="hidden md:flex items-center justify-between w-full mb-4 px-4 pt-4 md:pt-16 md:px-8">
			<div class="flex items-center ml-4 md:ml-0">
				<img :src="(currentTheme==='dark'||currentTheme==='navy') ? darkWallet : lightWallet" alt="Wallet Icon" class="w-6 h-6 md:w-8 md:h-8 mr-3"/>
				<h1 class="text-3xl md:text-4xl font-archivomedium text-[var(--text-color)]">
					<span class="hidden md:inline">
						{{ selectedChain.ticker }} 
					</span> 
					Wallet
				</h1>
			</div>
			<div class="relative flex items-center right-6">
				<div v-if="!btcOnly" class="md:hidden relative mr-2"></div>

				<!-- REFRESH -->
				<button @click="$emit('startSync')" class="text-[var(--text-color)] hover:text-[var(--text-color)]">
					<img src="../assets/Refresh.png" alt="Refresh Icon" class="w-6 h-6"/>
				</button>
			</div>
		</div>

		<!-- ACCOUNT DROPDOWN (MOBILE) -->
		<div v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" class="md:hidden flex flex-col items-center w-full mb-6 mt-4">
			<div class="relative flex w-full px-4">
				<div class="flex-grow relative">
					<button @click="$emit('toggleAccountDropdown')" class="w-full flex items-center justify-between bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg px-4 py-3 hover:shadow-xl transition-all duration-100">
						<span class="text-sm font-archivomedium text-[var(--secondary-text-color)]">
							{{ selectedAccount.name }}
							<span class="text-xs font-archivolight text-[var(--secondary-text-color)] ml-2">{{ shortAddress ? `[${shortAddress}]` : '' }}</span>
						</span>
						<svg :class="{'rotate-180 transform transition-transform duration-100': accountDropdownOpen}" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[var(--secondary-text-color)]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
						</svg>
					</button>

					<transition name="dropdown-transition">
						<div v-if="accountDropdownOpen" class="relative">
						<div class="fixed inset-0 z-10" @click="$emit('toggleAccountDropdown')"/>
							<div class="absolute left-0 mt-2 w-full bg-[var(--dropdown-bg-color)] rounded-lg shadow-lg z-20">
								<button v-for="account in walletAccounts[selectedChain.name]" :key="account.name" @click="$emit('selectAccount', account)" :class="[
								'w-full text-left px-4 py-3 rounded-lg hover:bg-[var(--accent-color)] transition-all duration-100 hover:text-[var(--hover-text-color)] text-[var(--secondary-text-color)]', account.name === selectedAccount.name ? 'opacity-40 hover:bg-[var(--dropdown-bg-color)] hover:text-[var(--secondary-text-color)]' : 'opacity-100']">
										{{ account.name }}
									<span class="text-xs ml-2">
										[{{ account.address ? account.address.slice(0, 4) + '....' + account.address.slice(-5) : '' }}]
									</span>
								</button>
								<button @click="$emit('openAddAccountPopup')" class="w-full text-left px-4 py-3 rounded-lg hover:bg-[var(--accent-color)] transition-all duration-100 hover:text-[var(--hover-text-color)] shadow-b shadow-xl text-[var(--secondary-text-color)]">
									<div class="flex items-center">
										<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? plusIconDarkTheme : plusIcon" alt="Plus Icon" class="w-5 h-5 mr-2"/>
										<span>
											Add Account
										</span>
									</div>
								</button>
							</div>
						</div>
					</transition>
				</div>

				<!-- COPY ADDRESS -->
				<button @click="$emit('copyWalletAddress')" class="flex items-center justify-center ml-2 w-12 bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg transition-all duration-100 hover:shadow-xl">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkCopy : lightCopy" alt="Copy Icon" class="w-5 h-5 cursor-pointer"/>
				</button>

				<!-- OPEN BLOCK EXPLORER -->
				<button @click="$emit('openBlockExplorer')" class="flex items-center justify-center ml-2 w-12 bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg transition-all duration-100 hover:shadow-xl">
					<img :src="explorerIcon" alt="Explorer" class="w-6 h-6" />
				</button>
			</div>
		</div>

		<!-- ACCOUNT DROPDOWN (DESKTOP) -->
		<div v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" class="hidden md:flex my-2 flex-col items-center mx-auto md:w-[85%] lg:w-[65%] xl:w-[55%]">
			<div class="relative flex w-5/6">
				<div class="flex-grow relative">
					<button @click="$emit('toggleAccountDropdown')" class="w-full flex items-center justify-between bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg px-4 py-3 hover:shadow-xl transition-all duration-100">
						<span class="text-base font-archivosemibold text-[var(--secondary-text-color)]">
							{{ selectedAccount.name }}
							<span class="text-sm font-archivolight ml-2">{{ shortAddress ? `[${shortAddress}]` : '' }}</span>
						</span>
						<svg :class="{'rotate-180 transform transition-transform duration-100': accountDropdownOpen}" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[var(--secondary-text-color)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" >
							<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M19 9l-7 7-7-7" />
						</svg>
					</button>

					<transition name="dropdown-transition">
						<div v-if="accountDropdownOpen" class="relative">
							<!-- backdrop -->
							<div class="fixed inset-0 z-10" @click="$emit('toggleAccountDropdown')"/>
							<!-- menu -->
							<div class="absolute left-0 mt-2 w-full bg-[var(--dropdown-bg-color)] bg-opacity-80 backdrop-blur-md rounded-lg shadow-lg transition-all duration-100 z-20">
								<button v-for="account in walletAccounts[selectedChain.name]" :key="account.name" @click="$emit('selectAccount', account)" :class="[
								'w-full text-left px-4 py-3 rounded-lg hover:bg-[var(--accent-color)] transition-all duration-100 hover:text-[var(--hover-text-color)] text-[var(--secondary-text-color)]', account.name === selectedAccount.name ? 'opacity-40 hover:bg-[var(--dropdown-bg-color)] hover:text-[var(--secondary-text-color)]' : 'opacity-100']">
									{{ account.name }}
									<span class="text-sm ml-2">
										[{{ account.address ? account.address.slice(0, 4) + '....' + account.address.slice(-5) : '' }}]
									</span>
								</button>
								<button @click="$emit('openAddAccountPopup')" class="w-full text-left px-4 py-3 rounded-lg hover:bg-[var(--accent-color)] transition-all duration-100 hover:text-[var(--hover-text-color)] text-[var(--secondary-text-color)]">
									<div class="flex items-center">
										<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? plusIconDarkTheme : plusIcon" alt="Plus Icon" class="w-5 h-5 mr-2"/>
										<span>
											Add Account
										</span>
									</div>
								</button>
							</div>
						</div>
					</transition>
				</div>

				<!-- COPY ADDRESS -->
				<button @click="$emit('copyWalletAddress')" class="flex items-center justify-center ml-2 w-12 bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg transition-all duration-100 hover:shadow-xl">
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkCopy : lightCopy" alt="Copy Icon" class="w-6 h-6 cursor-pointer" />
				</button>

				<!-- OPEN BLOCK EXPLORER -->
				<button @click="$emit('openBlockExplorer')" class="flex items-center justify-center ml-2 w-12 bg-[var(--dropdown-bg-color)] shadow-lg rounded-lg transition-all duration-100 hover:shadow-xl">
					<img :src="explorerIcon" alt="Explorer" class="w-6 h-6" />
				</button>
			</div>
		</div>

		<!-- MY PORTFOLIO/BALANCE -->
		<div class="w-[90%] mx-auto rounded-xl flex flex-col md:flex-row md:items-center border border-[var(--border-color)] justify-between px-6 shadow-xl md:my-6 mb-4 p-6 relative balance-bg">
			<div class="flex flex-col relative">
				<div class="flex items-center">
					<span class="text-[var(--secondary-text-color)] md:text-lg text-lg font-archivomedium">
						{{ balanceLabel }}
					</span>
					<img :src="(currentTheme === 'dark' || currentTheme === 'navy') ? darkEye : lightEye" alt="Eye Icon" class="w-5 h-5 ml-2 cursor-pointer" @click="$emit('toggleBalance')"/>
					<transition name="wave-blur">
						<button :key="showPortfolioUSD" @click="$emit('togglePortfolioUSD')" :title="showPortfolioUSD ? 'Show native balance' : 'Show USD total'" class="absolute top-0 right-0 md:static md:ml-2 p-1 rounded hover:bg-[var(--border-color)]" style="--index: 0">
							<svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-[var(--secondary-text-color)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
								<path stroke-linecap="round" stroke-linejoin="round" d="M3 8h7m0 0l-3 3m3-3l-3-3M21 16h-7m0 0l3-3m-3 3l3 3"/>
							</svg>
						</button>
					</transition>
				</div>

				<div class="my-2">
					<!-- Loading placeholder with stronger yet smooth blur -->
					<div v-if="isBalanceLoading" class="flex flex-col space-y-2">
						<div class="h-8 rounded bg-[var(--accent-color)] animate-smooth-heavy-blur" style="width: 10ch;"/>
						<div class="h-4 rounded bg-[var(--accent-color)] animate-smooth-heavy-blur" style="width: 6ch;"/>
					</div>
					<!-- Actual balances once loaded -->
					<div v-else>
						<div v-if="!showPortfolioUSD">
							<transition-group name="wave-blur" tag="span" class="flex items-baseline">
								<span v-for="(digit, i) in balanceDigits" :key="i" class="digit text-2xl font-archivoregular text-[var(--text-color)]" :style="{ '--index': i }" >
									{{ digit }}
								</span>
								<span class="digit text-2xl font-archivoregular text-[var(--text-color)] ml-1" :key="`ticker-${selectedChain.ticker}`" :style="{ '--index': balanceDigits.length }">
									{{ selectedChain.ticker }}
								</span>
							</transition-group>
							<transition-group name="wave-blur" tag="span" class="block mt-2 text-sm font-archivolight text-[var(--secondary-text-color)]">
								<span v-for="(char, i) in priceDigits" :key="i" class="digit" :style="{ '--index': i }">
									{{ char }}
								</span>
							</transition-group>
						</div>
						<div v-else>
							<div class="text-3xl font-archivoregular text-[var(--text-color)]">
								{{ portfolioChars }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- SEND/RECEIVE BUTTONS (DESKTOP) -->
			<div class="hidden md:flex flex-row items-center justify-center space-x-4 md:mr-8 mt-4 md:mt-0">
				<div @click="$emit('startSend')" class="flex flex-col items-center cursor-pointer">
					<img :src="currentTheme === 'dark' ? darkOrangeSend : (currentTheme === 'navy' ? darkSend : lightSend)" alt="Send Icon" class="w-9 h-9 md:w-10 md:h-10 mb-1 rounded-full hover:shadow-xl hover:animate-pulse"/>
					<button class="px-2 py-2 text-[var(--text-color)] font-archivoregular rounded-3xl hover:text-[var(--send-receive-text-color)] transition-colors duration-100">
						Send
					</button>
				</div>
				<div @click="$emit('showReceiveView')" class="flex flex-col items-center cursor-pointer">
					<img :src="currentTheme === 'dark' ? darkOrangeReceive : (currentTheme === 'navy' ? darkReceive : lightReceive)" alt="Receive Icon" class="w-9 h-9 md:w-10 md:h-10 mb-1 rounded-full hover:shadow-xl hover:animate-pulse"/>
					<button class="px-2 py-2 text-[var(--text-color)] font-archivoregular rounded-3xl hover:text-[var(--send-receive-text-color)]  transition-colors duration-100">
						Receive
					</button>
				</div>
			</div>
		</div>

		<!-- SEND/RECEIVE BUTTONS (MOBILE) -->
		<div class="flex md:hidden flex-row items-center justify-center space-x-4 my-4 w-full px-8">
			<button @click="$emit('startSend')" class="flex items-center justify-center border border-[var(--accent-color)] py-1 px-8 rounded-full bg-[var(--accent-color)] bg-opacity-10 text-[var(--hover-text-color)] transition duration-100 shadow-md hover:shadow-xl w-full font-archivoregular">
				Send
				<img :src="currentTheme === 'dark' ? darkOrangeSend : (currentTheme === 'navy' ? darkSend : lightSend)" alt="Send Icon" class="w-8 h-8"/>
			</button>
			<button @click="$emit('showReceiveView')" class="flex items-center justify-center border border-[var(--accent-color)] py-1 px-8 rounded-full bg-[var(--accent-color)] bg-opacity-10 text-[var(--hover-text-color)] transition duration-100 shadow-md hover:shadow-xl w-full font-archivoregular">
				Receive
				<img :src="currentTheme === 'dark' ? darkOrangeReceive : (currentTheme === 'navy' ? darkReceive : lightReceive)" alt="Receive Icon" class="w-8 h-8"/>
			</button>
		</div>

		<!-- TAB SWITCH -->
		<div class="md:w-[90%] w-[80%] mx-auto flex space-x-8 border-b border-[var(--border-color)] my-6">
			<button @click="emit('update:activeTab','assets')" :class="activeTab === 'assets' ? 'text-[var(--accent-color)] border-b-2 border-[var(--accent-color)]' : 'text-[var(--secondary-text-color)]'" class="pb-2 font-archivoregular transition-colors">
				My Assets
			</button>

			<button @click="emit('update:activeTab','history')" :class="activeTab === 'history' ? 'text-[var(--accent-color)] border-b-2 border-[var(--accent-color)]' : 'text-[var(--secondary-text-color)]'" class="pb-2 font-archivoregular transition-colors">
				Transaction History
			</button>
		</div>

		<!-- RECENT TRANSACTIONS -->
		<div v-if="activeTab === 'history'" class="w-full px-8 my-4">
			<h2 class="text-2xl font-archivolight text-[var(--text-color)] mb-4">	
				Recent Transactions
			</h2>

			<!-- 1) Loader while switching chains -->
			<div v-if="switchingChain || isSyncing || isBalanceLoading" class="flex justify-center py-12">
				<div class="loader"></div>
			</div>

			<!-- 2) No transactions (only when NOT switching) -->
			<div v-else-if="!recentTransactions.length" class="py-12 text-center text-[var(--secondary-text-color)]">
				No Tx’s Yet…
			</div>

			<div v-else class="bg-transparent rounded-lg">
				<div v-if="!switchingChain">
					<div v-if="selectedChain.name === 'Bitcoin'" class="overflow-x-auto overflow-visible">
						<table class="table-fixed min-w-[640px] w-full divide-y divide-[var(--border-color)] mb-4">
							<thead class="bg-[var(--myassets-bg-color)] rounded-t-lg overflow-hidden">
								<tr class="rounded-t-lg">
									<th class="first:rounded-tl-lg px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Status</th>
									<th class="px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Type</th>
									<th class="px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Inputs</th>
									<th class="px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Outputs</th>
									<th class="px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Amount</th>
									<th class="last:rounded-tr-lg px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">Conf.</th>
								</tr>
							</thead>
							<tbody class="bg-transparent divide-y divide-[var(--accent-color-50)]">
								<tr v-for="tx in recentTransactions" :key="tx.id" :class="{ 'bg-[#EC5900]/10': tx.status === 'Pending' }">
									<!-- status-->
									<td class="w-16 px-4 py-3 align-middle text-center">
										<div class="w-6 h-6">
										<!-- Confirmed -->
										<svg v-if="tx.status === 'Confirmed'" width="20" height="20" viewBox="0 0 16 16" class="drop-shadow-sm">
											<circle cx="8" cy="8" r="8" fill="#9FFFCA" />
											<path d="M4.5 8.5l2 2 4-4" stroke="#00671D" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<!-- Pending -->
										<svg v-else-if="tx.status === 'Pending'" width="20" height="20" viewBox="0 0 16 16" class="drop-shadow-sm">
											<circle cx="8" cy="8" r="8" fill="#FFD5AE" />
											<path d="M8 4v4M8 11h.01" stroke="#EC5900" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										<!-- Rejected -->
										<svg v-else width="20" height="20" viewBox="0 0 16 16" class="drop-shadow-sm">
											<circle cx="8" cy="8" r="8" fill="#FDB9B9" />
											<path d="M5 5l6 6M11 5l-6 6" stroke="#D40606" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
										</svg>
										</div>
									</td>
									<td class="px-4 py-3 text-xs">
										<span class="inline-flex whitespace-nowrap text-center" :class="{'bg-[var(--new-bg-received)] px-2 py-1 rounded-full text-[var(--new-text-receive)]': tx.type === 'Receive' || tx.type === 'Received', 'bg-[var(--new-bg-sent)] px-3 py-1 rounded-full text-[var(--new-text-sent)]' : tx.type === 'Send' || tx.type === 'Sent'}">
											{{ tx.type }}
										</span>
									</td>
									<!-- inputs -->
									<td class="px-4 py-3 align-middle">
										<div v-for="(inp,i) in tx.inputsArr" :key="i" class="relative group mb-1">
											<span class="truncate text-xs text-[var(--btc-tx-block-colour)] cursor-pointer">
												{{ inp.slice(0,7) + '...' + inp.slice(-5) }}
											</span>
											<div class="absolute left-0 bottom-full mb-1 hidden group-hover:block bg-[var(--dropdown-tx-history-bg-color)] text-[var(--text-color)] text-xs px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
												{{ inp }}
											</div>
										</div>
									</td>
									<!-- outputs -->
									<td class="px-4 py-3 align-middle text-[var(--text-color)]">
										<div v-for="(out,j) in tx.outputsArr" :key="j" class="relative group mb-1 flex items-baseline">
											<span class="truncate text-xs text-[var(--btc-tx-block-colour)] cursor-pointer">
												{{ out.slice(0,7) + '...' + out.slice(-5) }}
											</span>
											<div class="absolute left-0 bottom-full mb-1 hidden group-hover:block bg-[var(--dropdown-tx-history-bg-color)] text-[var(--text-color)] text-xs px-3 py-2 rounded shadow-lg whitespace-nowrap z-50">
												{{ out }}
											</div>
										</div>
									</td>

									<td class="px-4 py-3 text-[var(--btc-tx-amount-colour)] align-middle">
										<div v-for="(addr, j) in tx.outputsArr" :key="j" class="flex items-baseline text-xs mb-1">
											<span class="ml-2 text-xs text-[var(--text-color)]">
												{{ tx.outputValuesArr[j] }}
											</span>
										</div>
									</td>

									<td class="px-4 py-3 text-xs text-[var(--btc-tx-confirmations-colour)] align-middle">
									{{ tx.confirmations }}
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				
					<div v-else class="overflow-x-auto overflow-visible">
						<table class="table-auto md:table-fixed w-full divide-y divide-[var(--border-color)]">
							<thead class="bg-[var(--myassets-bg-color)] rounded-t-lg overflow-hidden">
								<tr class="rounded-t-lg">
									<th class="w-1/4 first:rounded-tl-lg px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">
										Block
									</th>
									<th class="w-1/4 px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">
										Type
									</th>
									<th class="w-1/4 px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">
										Amount
									</th>
									<th class="w-1/4 last:rounded-tr-lg px-4 py-2 text-left text-xs font-archivosemibold text-[var(--secondary-text-color)] uppercase">
										Tx Hash
									</th>
								</tr>
							</thead>
							<tbody class="bg-transparent divide-y divide-[var(--accent-color-50)]">
								<tr  v-for="tx in recentTransactions" :key="tx.id" :class="{'opacity-30': i === 1}" >
									<td class="px-4 py-3 text-xs text-[var(--evm-tx-block-colour)]">
										{{ tx.block  }}
									</td>
									<!--<td class="px-4 py-3 text-sm text-[var(--text-color)]">-->
									<td class="px-4 py-3 text-xs">
										<span class="inline-block whitespace-normal px-3 py-1 rounded-full leading-tight text-center"
										:class="{
										'text-[var(--text-color)]': !(tx.amount.split(' ')[0] === '0' || tx.type === 'Sent' || tx.type === 'Received'),
										'bg-[var(--new-bg-received)] px-2 py-1 rounded-full text-[var(--new-text-receive)]': tx.type === 'Received',
										'bg-[var(--new-bg-sent)] px-3 py-1 rounded-full text-[var(--new-text-sent)]': tx.type === 'Sent',
										'bg-[var(--new-bg-swap)] px-2 py-1 rounded-full text-[var(--new-text-swap)]': tx.amount.split(' ')[0] === '0'
										}">
											{{ tx.amount.split(' ')[0] === '0' ? 'Smart Contract' : tx.type }}
										</span>
									</td>

									<!-- amount -->
									<td class="px-4 py-3 text-xs text-[var(--evm-tx-amount-colour)]">
										{{ tx.amount.split(' ')[0] === '0' ? '-' : tx.amount }}
									</td>
									<!-- hash desktop -->
									<td class="hidden md:table-cell px-4 py-3">
										<div class="relative group">
											<button @click="copyHash(tx.hash)" class="text-xs px-2 text-[var(--evm-tx-hash-colour)] truncate block">
												{{ tx.hash.slice(0,6) + '...' + tx.hash.slice(-6) }}
											</button>
											<div class="hidden group-hover:block absolute right-0 bottom-full mb-1 bg-[var(--dropdown-tx-history-bg-color)] text-[var(--text-color)] text-xs px-3 py-2 rounded shadow-lg whitespace-nowrap z-20">
												{{ tx.hash }}
											</div>
										</div>
									</td>
									<!-- hash cipy icon -->
									<td class="md:hidden px-4 py-3 flex justify-center">
										<button @click="copyHash(tx.hash)" class="p-2" :title="tx.hash">
											<img :src="(currentTheme==='dark' || currentTheme==='navy') ? darkCopy : lightCopy" alt="Copy Icon" class="w-5 h-5"/>
										</button>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="allTransactions.length > 0" class="flex justify-center mt-3 mb-4">
						<button @click="showHistory = true" class="text-[var(--accent-color)] font-archivolight hover:underline">
						See More Details
						</button>
					</div>
				</div>
			</div>
		</div>

		<!-- MY ASSETS -->
		<div v-if="activeTab === 'assets'" class="w-full px-8 my-4">
			<!-- Header + EVM controls on one line -->
			<div class="flex items-center justify-between">
				<h2 class="text-2xl font-archivolight text-[var(--text-color)]">
					My Assets
				</h2>

				<div class="flex items-center space-x-4">
					<!-- 3-dot dropdown on mobile -->
					<div v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" class="block md:hidden relative">
						<button @click="toggleTokenContractDropdown" class="flex items-center justify-center w-10 h-10 text-[var(--accent-color)] focus:outline-none">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="currentColor" viewBox="0 0 24 24">
								<path d="M12 7a2 2 0 110-4 2 2 0 010 4zM12 13a2 2 0 110-4 2 2 0 010 4zM12 19a2 2 0 110-4 2 2 0 010 4z"/>
							</svg>
						</button>
						<transition name="dropdown-transition">
						<div v-if="tokenContractDropdownOpen" class="relative">
							<div class="fixed inset-0 z-10" @click="$emit('toggleTokenContractDropdown')" />
								<div @click.stop class="absolute right-0 mt-2 z-30 w-44 hover:bg-[var(--dropdown-bg-color)] rounded-full bg-[var(--accent-color)] text-[var(--drop-popup-text-color)] hover:text-[var(--address-popup-text-color)] transition duration-200 cursor-pointer hover:shadow-xl border border-[var(--accent-color)] font-archivoregular py-2 px-4 shadow-lg">
									<button @click="$emit('openAddTokenPopup')" class="w-full text-left">
										Add Token Contract
									</button>
								</div>
							</div>
						</transition>
					</div>

					<!-- “Add Token Contract” on desktop -->
					<div v-if="!btcOnly && selectedChain.name !== 'Bitcoin'" class="hidden md:block">
						<button @click="$emit('openAddTokenPopup')"
						class="hover:bg-[var(--new-dropdown-bg-color)] rounded-full bg-[var(--accent-color)] text-[var(--drop-popup-text-color)] hover:text-[var(--address-popup-text-color)] transition duration-200 cursor-pointer text-sm border border-[var(--accent-color)] font-archivoregular py-1.5 px-4 shadow-xl">
							Add Token Contract
						</button>
					</div>
				</div>
			</div>

			<!-- 1) Loader while switching chains -->
			<div v-if="switchingChain || isSyncing || isBalanceLoading" class="flex justify-center py-12">
				<div class="loader"></div>
			</div>
		</div>

		<!-- ASSET BLOCKS -->
		<div v-if="activeTab === 'assets' && !switchingChain && !isSyncing && !isBalanceLoading" class="w-full space-y-4 px-8 pb-4 mb-32">
			<div v-for="asset in assetList" :key="asset.address" class="bg-[var(--myassets-bg-color)] rounded-lg shadow-inner hover:shadow-md transition">

				<!-- ASSET BLOCKS (DESKTOP) -->
				<div class="hidden md:flex items-center justify-between p-4">
					<div class="flex items-center space-x-3">
						<img :src="asset.icon" class="w-8 h-8 rounded" />
						<div class="flex flex-col">
							<span class="text-lg font-archivomedium text-[var(--text-color)]">
								{{ asset.name }}
							</span>
							<span class="text-sm font-archivolight text-[var(--secondary-text-color)]">
								{{ asset.symbol }}
							</span>
							<p v-if="selectedChain.name === 'Bitcoin' && showUnconf" class="text-md font-archivoregular text-[var(--unconf-color)]">+
								<span class="mt-2 text-sm font-archivoregular text-[var(--unconf-color)]">
								{{ showBalance ? unconfirmedBalance : '••••••' }} {{ asset.symbol }}
							</span>
							</p>
						</div>
					</div>
					<div class="flex items-center space-x-6">

						<!-- BALANCE -->
						<transition-group name="wave-blur" tag="span" class="text-lg font-archivoregular text-[var(--text-color)]">
							<span v-for="(char, i) in (showBalance ? asset.balance.toString().split('') : '••••••'.split(''))" :key="`${asset.address}-${asset.balance}-${i}`" class="digit" :style="{ '--index': i }">
								{{ char }}
							</span>
						</transition-group>

						<!--  PRICE -->
						<div v-if="asset.price != null && !isNaN(asset.price)">
							<transition-group name="wave-blur" tag="span" class="text-sm font-archivolight text-[var(--secondary-text-color)]">
								<span v-for="(char, i) in (showBalance && asset.price != null && !isNaN(asset.price) ? `$${asset.price.toFixed(2)}`.split('') : '•••'.split(''))"
								:key="`${asset.address}-${showBalance ? asset.price.toFixed(2) : 'dots'}-${i}`" class="digit" :style="{ '--index': i }">
									{{ char }}
								</span>
							</transition-group>
						</div>
						<div v-else>
							<span class="text-sm font-archivolight text-[var(--secondary-text-color)]">
								...
							</span>
						</div>

						<div class="relative">
							<button  @click="$emit('openAssetMenu', asset.address)" class="p-2 hover:bg-[var(--dropdown-hover-color)] rounded-full">
							<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[var(--secondary-text-color)]" viewBox="0 0 20 20" fill="currentColor">
								<path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z"/>
							</svg>
							</button>
							<transition name="dropdown-transition">
								<div v-if="assetMenuOpen === asset.address" class="relative">
									<div class="fixed inset-0 z-10" @click="$emit('openAssetMenu', null)" />
									<ul class="absolute right-0 mt-2 w-40 bg-[var(--dropdown-bg-color)] rounded-lg hover:rounded-lg shadow-lg z-20">
										<li @click="onSelectSend(asset)" class="px-4 py-2 rounded-lg overflow-hidden hover:bg-[var(--accent-color)] hover:text-[var(--drop-popup-text-color)] text-[var(--address-popup-text-color)] transition cursor-pointer">
											Send
										</li>
										<li @click="onSelectReceive(asset)" class="px-4 py-2 rounded-lg overflow-hidden hover:bg-[var(--accent-color)] hover:text-[var(--drop-popup-text-color)] text-[var(--address-popup-text-color)] transition cursor-pointer">
											Receive
										</li>
										<li v-if="canRemove(asset)" @click="onSelectRemove(asset)" class="px-4 py-2 rounded-lg overflow-hidden text-red-600 hover:bg-red-100 transition cursor-pointer">
											Remove
										</li>
									</ul>
								</div>
							</transition>
						</div>
					</div>
				</div>

				<!-- ASSET BLOCKS (MOBILE) -->
				<div class="flex md:hidden items-center justify-between p-4">
					<div class="flex items-center space-x-3">
						<img :src="asset.icon" class="w-7 h-7 rounded" />
						<div class="flex flex-col">
							<span class="text-base font-archivomedium text-[var(--text-color)]">{{ asset.name }}</span>
							<span class="text-sm font-archivolight text-[var(--secondary-text-color)]">{{ asset.symbol }}</span>
							<span class="mt-2 text-md font-archivoregular text-[var(--text-color)]">{{ showBalance ? asset.balance : '••••••' }}</span>
							<p v-if="selectedChain.name === 'Bitcoin' && showUnconf" class="text-md font-archivoregular text-[var(--unconf-color)]">+
								<span class="text-sm font-archivoregular text-[var(--unconf-color)]">
									{{ showBalance ? unconfirmedBalance : '••••••' }} {{ asset.symbol }}
								</span>
							</p>
						</div>
					</div>
					<div class="flex items-center space-x-2">

						<!-- PRICE -->
						<div v-if="asset.price != null && !isNaN(asset.price)" class="mr-2">
							<transition-group name="wave-blur" tag="span" class="text-sm font-archivolight text-[var(--secondary-text-color)]">
								<span v-for="(char, i) in (showBalance && asset.price != null && !isNaN(asset.price) ? `$${asset.price.toFixed(2)}`.split('') : '•••'.split(''))"
								:key="`${asset.address}-${showBalance ? asset.price.toFixed(2) : 'dots'}-${i}`" class="digit" :style="{ '--index': i }">
									{{ char }}
								</span>
							</transition-group>
						</div>
						<!-- <span class="text-sm font-archivolight text-[var(--secondary-text-color)]">{{ asset.price != null ? `$${asset.price.toFixed(2)}` : '...' }}</span> -->
						<div class="relative">
							<button @click="$emit('openAssetMenu', asset.address)" class="p-2 hover:bg-[var(--dropdown-hover-color)] rounded-full">
								<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-[var(--secondary-text-color)]" viewBox="0 0 20 20" fill="currentColor">
									<path d="M6 10a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm6 0a2 2 0 11-4 0 2 2 0 014 0z"/>
								</svg>
							</button>
							<transition name="dropdown-transition">
								<div v-if="assetMenuOpen === asset.address" class="relative">
									<div class="fixed inset-0 z-10" @click="$emit('openAssetMenu', null)"/>
									<ul class="absolute right-0 mt-2 w-36 bg-[var(--dropdown-bg-color)] rounded-lg shadow-lg z-20">
										<li @click="onSelectSend(asset)" class="px-4 py-2 rounded-lg overflow-hidden hover:bg-[var(--accent-color)] text-[var(--address-popup-text-color)] hover:text-[var(--drop-popup-text-color)] transition cursor-pointer">
											Send
										</li>
										<li @click="onSelectReceive(asset)" class="px-4 py-2 rounded-lg overflow-hidden hover:bg-[var(--accent-color)] text-[var(--address-popup-text-color)] hover:text-[var(--drop-popup-text-color)] transition cursor-pointer">
											Receive
										</li>
										<li v-if="canRemove(asset)" @click="onSelectRemove(asset)" class="px-4 py-2 rounded-lg overflow-hidden text-red-600 hover:bg-red-100 transition cursor-pointer">
											Remove
										</li>
									</ul>
								</div>
							</transition>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import lightWallet from '../assets/5Wallet.png';
	import darkWallet from '../assets/WalletWhite1.png';
	import lightEye from '../assets/eye.png';
	import darkEye from '../assets/eyeWhite.png';
	import lightSend from '../assets/Send_Copper.png';
	import darkSend from '../assets/SendIconOrange.png';
	import darkOrangeSend from '../assets/Dark_Orange_Send.png';
	import lightReceive from '../assets/Receive_Copper.png';
	import darkReceive from '../assets/ReceiveIconOrange.png';
	import darkOrangeReceive from '../assets/Dark_Orange_Receive.png';
	import lightCopy from '../assets/LightCopyIcon.png';
	import darkCopy from '../assets/DarkCopyIcon.png';
	import plusIcon from '../assets/PlusLightTheme.png';
	import plusIconDarkTheme from '../assets/PlusDarkTheme.png';

	const props = defineProps({
		currentTheme: { type: String, required: true },
		btcOnly: { type: Boolean, required: true },
		selectedChain: { type: Object, required: true },
		selectedAccount: { type: Object, required: true },
		shortAddress: { type: String, required: true },
		showUnconf: { type: Boolean, required: true },
		unconfirmedBalance: { type: [String, Number], required: true },
		walletAccounts: { type: Object, required: true },
		accountDropdownOpen: { type: Boolean, required: true },
		assetList: { type: Array, required: true },
		showBalance: { type: Boolean, required: true },
		displayedBalance: { type: [String, Number], required: true },
		balanceDigits: { type: Array, required: true },
		priceDigits: { type: Array, required: true },
		balanceLabel: { type: String, required: true },
		showPortfolioUSD: { type: Boolean, required: true },
		portfolioValue: { type: [String, Number], required: true },
		assetMenuOpen: { type: Boolean, required: true },
		explorerIcon: { type: String, required: true },
		chainDropdownOpen: { type: Boolean, required: true },
		displayedChains: { type: Array, required: true },
		tokenContractDropdownOpen: { type: Boolean, required: true },
		activeTab: { type: String,  required: true },
		switchingChain: { type: Boolean, required: true },
		isSyncing: { type: Boolean, required: true },
		isBalanceLoading: { type: Boolean, required: true },
		recentTransactions: { type: Array, required: true },
		allTransactions: { type: Array, required: true },
	});

	const emit = defineEmits([
		'startSync',
		'startSend',
		'showReceiveView',
		'toggleBalance',
		'togglePortfolioUSD',
		'toggleAccountDropdown',
		'toggleTokenContractDropdown',
		'toggleChainDropdown',
		'selectAccount',
		'selectChain',
		'openAddTokenPopup',
		'openAddAccountPopup',
		'copyWalletAddress',
		'openBlockExplorer',
		'openAssetMenu',
		'onSelectSend',
		'onSelectReceive',
		'onSelectRemove',
		'update:activeTab',
	]);

	const canRemove = asset => {
		const blocked = [ props.selectedChain.ticker, 'USDT', 'USDC' ]
		return !blocked.includes(asset.symbol)
	}

	</script>

<style scoped>

	.loader {
		border: 8px solid #f3f3f3;
		border-top: 8px solid var(--accent-color);
		border-radius: 50%;
		width: 28px;
		height: 28px;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	/* make sure your horizontal rules match your border color */
	hr {
		border-color: var(--border-color);
	}

	/* the background behind the whole wallet area */
	.pair-bg {
		background: var(--main-bg-color);
	}

	/* the styled scrollbars on the asset list and overview panels */
	.custom-scrollbar {
		/* firefox */
		overflow-y: auto;
		scrollbar-width: thin;
		scrollbar-color: #888 #f1f1f1;
	}
	/* Chrome, Edge, Safari */
	.custom-scrollbar::-webkit-scrollbar {
		width: 8px;
	}
	.custom-scrollbar::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 16px;
		margin: 5% 0;
	}
	.custom-scrollbar::-webkit-scrollbar-thumb {
		background-color: #888;
		border-radius: 8px;
	}
	.custom-scrollbar::-webkit-scrollbar-thumb:hover {
		background-color: #555;
	}

	/* the “show USD vs native” toggle panel */
	.balance-bg {
		background: var(--balance-bg-color);
	}

	/* the fade‐in/fade‐out for your <transition name="fade"> wrappers */
	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.2s ease-in-out;
	}
	.fade-enter-from,
	.fade-leave-to {
		opacity: 0;
	}

	/* the staggered “wave blur” for your balance & price digits */
	@keyframes waveBlur {
		0%   { filter: blur(6px); opacity: 0.4; }
		50%  { filter: blur(2px); opacity: 0.8; }
		100% { filter: blur(0);   opacity: 1;   }
	}
	.wave-blur-enter-active {
		display: inline-block;
		animation: waveBlur 0.8s ease-out forwards;
		animation-delay: calc(var(--index) * 0.04s);
	}
	.wave-blur-enter-from {
		filter: blur(8px);
		opacity: 0;
	}
	.wave-blur-leave-active {
		animation: none !important;
		transition: none !important;
	}
	.wave-blur-leave-to {
		filter: blur(0);
		opacity: 0;
	}

	/* each “digit” needs an index var and inline‐block for those animations */
	.digit {
		--index: 0;
		display: inline-block;
	}


	/* in your <style scoped> */

	@keyframes smooth-heavy-blur {
		0%, 100% {
			opacity: 0.6;
			filter: blur(16px);
		}
		50% {
			opacity: 0.8;
			filter: blur(10px);
		}
	}

	.animate-smooth-heavy-blur {
		animation: smooth-heavy-blur 2s ease-in-out infinite;
	}

	/* style scoped */
	.dropdown-transition-enter-active,
	.dropdown-transition-leave-active {
		transition: opacity 10ms ease, transform 10ms ease;
	}

	.dropdown-transition-enter-from,
	.dropdown-transition-leave-to {
		opacity: 0;
		transform: scale(0.95);
	}

	.dropdown-transition-enter-to,
	.dropdown-transition-leave-from {
		opacity: 1;
		transform: scale(1);
	}


</style>